/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Waterefgconsumption2Inputs */



/**
* | output |
* | --- |
* | "General cold water consumption" |
*
* @param {Br_History_Key_Waterefgconsumption2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_waterefgconsumption2 = /** @type {((inputs?: Br_History_Key_Waterefgconsumption2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Waterefgconsumption2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("General cold water consumption")
	return /** @type {LocalizedString} */ ("Consommation d'eau froide générale")
});
export { br_history_key_waterefgconsumption2 as "br_history_key_waterEfgConsumption" }